import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import CronJobEditor from 'Utils/CronJobEditor';

const ConnectionOptionsModal = (data) => {
  const { host, show, setShow, runSearch, scheduleExpression, scheduleRules, setData } = data;
  const [scheduleExpressionValue, setScheduleExpressionValue] = useState(scheduleExpression);
  const [scheduleRulesValue, setScheduleRulesValue] = useState(scheduleRules);
  const [runSearchValue, setRunSearchValue] = useState(runSearch);

  const handleSaveOptions = () => {
    setData({
      ...data,
      scheduleExpression: scheduleExpressionValue,
      scheduleRules: scheduleRulesValue,
      runSearch: runSearchValue,
      modified: true
    });
    setShow(false);
  }

  return (
    <Modal
      onHide={() => setShow(false)}
      show={show}
    >
      <Modal.Header closeButton>
        DATA SOURCE OPTIONS
      </Modal.Header>
      <Modal.Body>
        <Row className='mb-4'>
          <Col>
            <div className='ls-insight-label'>
              <b>HOST OR S3 URL</b>
            </div>
            <div style={{ fontSize: '12px' }}>
              { host }
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Check 
              checked={runSearchValue}
              onChange={(e) => setRunSearchValue(e.target.checked)}
              className='mb-4'
              type='checkbox'
              label='Automatically initiate a scan for this data source after saving this Data Source. ( Recommended )' 
              size='sm'
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CronJobEditor
              scheduleExpression={scheduleExpressionValue}
              scheduleRules={scheduleRulesValue}
              setScheduleData={(v) => {
                setScheduleExpressionValue(v.scheduleExpression);
                setScheduleRulesValue(v.scheduleRules);
              }}
            />
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col className='pr-1'>
            <Button
              variant='outline-secondary'
              onClick={() => setShow(false)}
              className='w-100'
            >
              CLOSE
            </Button>
          </Col>
          <Col className='pl-1'>
            <Button 
              variant='primary' 
              onClick={() => handleSaveOptions()} 
              className='w-100'
            >
              SAVE OPTIONS
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default ConnectionOptionsModal;